import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import {AngularFireDatabase} from 'angularfire2/database';

@Component({
  selector: 'app-view-users',
  templateUrl: './view-users.component.html',
  styleUrls: ['./view-users.component.scss']
})
export class ViewUserComponent {




userDetails:any={};
  constructor(private route: ActivatedRoute,  public router: Router, public af: AngularFireDatabase) {

  	 	 	this.route.params.map(params => params['id']).subscribe((Id) => {
  	 	    if(Id != null) {
		  this.af.object('/users/' + Id).subscribe(
		        (response) => { 
		        	this.userDetails = response;
		         }
		      )
          }
       });  	
  }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/users/view-user/view-users.component.ts